var PostResolveSize = function (width, height) {    
}

export default PostResolveSize;